export enum Sender {
  REPORTER = "REPORTER",
  ADMIN = "ADMIN",
  BOT = "BOT"
}
